<template>
  <el-dialog
    :visible="visible"
    :show-close="showClose"
    :width="width"
    :modal="isShowModal"
    class="common-center-dialog-container"
    :custom-class="customClass"
    :append-to-body="appendToBody"
    :modal-append-to-body="modalAppendToBody"
  >
    <div v-if="showHeader" slot="title" class="common-center-dialog-header">
      <span class="title" v-if="brTitle">
        <span class="title">{{ brTitle1 }}</span> <br />
        <span class="title">{{ brTitle2 }}</span>
      </span>

      <span class="title" v-else>{{ title }}</span>
      <img
        :src="closeIcon || require('../images/dialogClose.svg')"
        alt=""
        class="close-container"
        @click="handleClose"
      />
    </div>
    <div slot="title" class="header-line line" v-if="showHeaderLine">
      <div class="tips" v-if="showHeaderTips">
        Please select shippers/brokers first, then upload the RC document.
      </div>
    </div>
    <slot></slot>
    <div slot="footer" class="header-line line" v-if="showFooterLine"></div>
    <div v-if="showFooter" slot="footer" class="common-center-dialog-footer">
      <slot class="footer-left" name="footer-left"></slot>
      <div class="footer-controller">
        <!-- <span class="cancel-btn" @click="handleClose" v-if="showCloseBtn">{{
          closeText
        }}</span> -->
        <common-button 
          :size="buttonSize"
          @click="handleClose" 
          v-if="showCloseBtn">{{
          closeText.toUpperCase()
        }}</common-button>
        <common-button
          type="primary"
          @click="handleSubmit"
          :disabled="disabled"
          v-if="showSubmitBtn"
          :loading="loading"
          :size="buttonSize"
          >{{ submitText.toUpperCase() }}</common-button
        >
        <!-- <el-button
          type="primary"
          class="save-btn"
          :disabled="disabled"
          :loading="loading"
          @click="handleSubmit"
          >{{ submitText }}</el-button
        > -->
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    calcelType: {
      type: String,
      default: 'text'
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    visible: {
      type: Boolean,
      default: false,
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    showSubmitBtn: {
      type: Boolean,
      default: true,
    },
    brTitle: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "588px",
    },
    customClass: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    closeText: {
      type: String,
      default: "Cancel",
    },
    submitText: {
      type: String,
      default: "Save",
    },
    showHeaderLine: {
      type: Boolean,
      default: false,
    },
    showFooterLine: {
      type: Boolean,
      default: false,
    },
    showHeaderTips: {
      type: Boolean,
      default: false,
    },
    isShowModal: {
      type: Boolean,
      default: true,
    },
    closeIcon: {
      default: null,
    },
    modalAppendToBody: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      brTitle1: "",
      brTitle2: "",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$emit("submit");
    },
  },
  created() {
    if (this.brTitle) {
      this.brTitle1 = this.title.split("<br>")[0];
      this.brTitle2 = this.title.split("<br>")[1];
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.common-center-dialog-container {
  ::v-deep {
    .el-dialog {
      margin: 0 !important;
      padding: 0 !important;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      box-shadow: 0 0 10px 0 rgba(70, 83, 106, 0.2);
      border-radius: 4px !important;
      .el-dialog__header {
        padding: 0 !important;
        .common-center-dialog-header {
          border-bottom: 1px solid #E7EBF3;
          padding: 20px 24px !important;
          // height: 66px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title {
            font-weight: bold;
            font-size: 18px;
            font-weight: bold;
            color: #000000;
          }
          .close-container {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
      }
      .el-dialog__body {
        padding: 20px 24px;
        word-break: normal !important;
        // min-height: 100px;
      }
      .el-dialog__footer {
        border-top: 1px solid #E7EBF3;
        padding: 20px 24px !important;
        .common-center-dialog-footer {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .footer-controller {
            flex-shrink: 0;
            display: flex;
          }
          .cancel-btn {
            cursor: pointer;
            width: 65px;
            height: 32px;
            border-radius: 4px;
            background-color: #dadce1;
            font-weight: 600;
            font-size: 14px;
            font-weight: 600;
            color: #4c556c;
            display: inline-block;
            line-height: 32px;
            text-align: center;
            margin-right: 16px;
            // &:hover {
            //   color: #000000;
            // }
          }
          .save-btn {
            // width: 52px;
            // height: 32px;
            padding: 5px 10px;
            border-radius: 4px;
            span {
              font-weight: 600 !important;
              font-size: 14px;
              font-weight: 600;
            }
            background: #4066d4;
            &:hover {
              background: #4066d4;
            }
          }
          .save-btn.is-disabled {
            span {
              font-weight: 600 !important;
              font-size: 14px;
              font-weight: 600;
            }
            background: #dadce1;
            border-color: #dadce1;
          }
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #dadce1;
    .tips {
      position: absolute;
      width: 294px;
      top: 50px;
      left: 24px;
      font-weight: 500;
      font-size: 12px;
      // line-height: 1.33;
      font-weight: 500;
      color: #7f8596;
    }
  }
}

</style>
